import React from 'react';
export const StructuredData = ({ json }) => {
    return (React.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
            __html: JSON.stringify(json)
        } }));
};
//# sourceMappingURL=StructuredData.js.map